import { useQuery } from '@tanstack/react-query';
import type { EarningsSummary, TeenOverview } from '@teentack/shared';
import { fetchMyEarnings, fetchTeenOverview } from './teen.api';

export const teenKeys = {
  overview: ['teen', 'overview'] as const,
  earnings: ['teen', 'earnings'] as const,
};

export function useTeenOverview(enabled = true) {
  return useQuery<TeenOverview>({
    queryKey: teenKeys.overview,
    queryFn: fetchTeenOverview,
    enabled,
    staleTime: 15_000,
  });
}

export function useMyEarnings(enabled = true) {
  return useQuery<EarningsSummary>({
    queryKey: teenKeys.earnings,
    queryFn: fetchMyEarnings,
    enabled,
    staleTime: 30_000,
  });
}
